import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/:village',
            redirect: '/0/:village'
        },
        {
            path: '/:site/:village',
            name: 'home',
            component: Home
        },
        {
            path: '/edit/:village',
            name: 'home',
            component: Home
        },
        {
            path: '/square/:village',
            name: 'home',
            component: Home
        },
        {
            path: '*',
            redirect: '/'
        },
    ],
    mode: 'hash'
})
